<template>
  <div>
    <!-- <ul class="xuexikecheng"> -->
    <li v-for="(item, index) in list" :key="index">
      <router-link :to="{ path: '/courseDeatil', query: { id: item.id } }">
        <img :src="item.picUrl" />
      </router-link>
      <h4>
        <a href="javascript:;">{{ $util.cutStr(item.name, 12) }}</a>
      </h4>
      <span>{{ item.hits }}浏览</span>
      <span>
        <i>{{ item.totalHour }}</i
        >课时
      </span>
      <p v-if="item.isGratis == 0">¥{{ item.presentPrice.toFixed(2) }}</p>
      <p v-else>免费</p>
    </li>
    <!-- </ul> -->
  </div>
</template>

<script>
export default {
  name: "single-course",
  data() {
    return {
      list: [],
    };
  },
  
  watch:{
    courseList(value){
      this.list=value
    }
  },
  props: {
    courseList: {
      type: Array,
      default() {
        return [];
      },
    },
    showMoney: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    courseList() {
      this.list = this.courseList;
    },
  },
  mounted() {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/singleCourse.vue